<template>
  <div v-loading="loading">
    <div class="op">
      <div class="idc">
        <el-input v-model="idNo" @change="toup" size="mini" clearable placeholder="请输入身份证号"></el-input>
      </div>
      <el-button type="primary" size="mini" style="background:#148A9B;margin-left:60px" icon="el-icon-search"
        @click="serch">搜索</el-button>
      <kt-button icon="fa fa-plus" label="新增基础信息" perms="lib:menu:add" type="success" @click="addMessage" />
    </div>
    <div class="contend" v-show="isShow">
      <div class="detialMsg">
        <div class="ownMsg">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="ku">个人基础信息</span>
              <kt-button class="changeBasic" size="mini" icon="fa el-icon-delete" type="warning" perms="lib:info:delete"
                @click="delBasicInfo" label="删除个人信息"></kt-button>
              <kt-button class="changeBasic" icon="fa el-icon-edit" label="修改基础信息" perms="lib:menu:edit" type="primary"
                @click="changeBasicInfo" />
            </div>
            <div class="text">
              <div class="basicPhoto">
                <img :src="basicPhoto" alt="">
              </div>
              <ul class="basicInfo">
                <li><span>姓名</span>:{{ personName }}<span style="margin-left:50px">手机号码</span>:{{ telphone }}</li>
                <li><span>身份证号</span>:{{ idc }}</li>
                <li><span>所在地区</span>:{{ value.split(",")[0] }}</li>
                <li><span>入库时间</span>:{{ operate_name }}</li>
                <li><span>数据来源</span>:{{ isNew }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>年龄</span>:{{ age }}</li>
                <li><span>银行卡号</span>:{{ value.split(",")[2] }} <kt-button class="changeSta" size="mini"
                    icon="fa el-icon-edit" label="修改" perms="update:bank:card" type="primary" @click="changeBank()">修改
                  </kt-button>
                </li>
                <li><span>开卡银行</span>:{{ value.split(",")[5] }}</li>
                <li><span>补贴类型:</span>
                  <el-select size="mini" v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </li>
                <li><span>个人状态</span>:{{ bak01 }}<kt-button class="changeSta" size="mini" icon="fa el-icon-edit"
                    label="修改" perms="update:col:state" type="primary" @click="changeSta"></kt-button><span
                    class="changeSta" @click="look(6)">查看</span> </li>
                <li><span>补贴状态</span>:{{ value.split(",")[3] }}<kt-button class="changeSta" size="mini"
                    icon="fa el-icon-edit" label="修改" perms="update:adr:state" type="primary" @click="cbchangeSta">修改
                  </kt-button><span class="changeSta" @click="look(1)">查看</span> </li>
                <li>
                  <kt-button class="changeBasic" size="mini" icon="fa el-icon-edit" label="修改"
                    perms="update:adr:recordTime" type="primary" @click="cbchangever">
                  </kt-button>
                </li>
                <li><span>认证时间</span>:{{ value.split(",")[9] == "null" ? '' : value.split(",")[9] }} </li>
                <li><span>备注</span>:{{ value.split(",")[8] == "null" ? '' : value.split(",")[8] }} </li>
              </ul>
            </div>
          </el-card>
        </div>
        <div class="photoList">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="ku2">库中照片列表</span>
            </div>
            <div class="text kuImg">
              <img v-for="(itme, index) in featureDtoList" :key="index" :src="imgUrl + itme.pictureInfo" alt="">
            </div>
          </el-card>
        </div>
      </div>
      <div class="List">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>认证列表</span>
            <kt-button icon="fa fa-plus" label="新增认证记录" perms="add:auth:record" type="success"
              @click="isaddRecord = true" />
          </div>
          <div class="text">
            <el-table :data="tableData" style="width: 100%" stripe>
              <el-table-column prop="createtime" width="100" label="认证照片">
                <template slot-scope="scope">
                  <el-popover placement="left" title="" trigger="hover">
                    <img slot="reference"
                      :src="(scope.row.recordPhoto ? (imgUrl + scope.row.recordPhoto) : '') || defaultImg" height="70"
                      class="head_pic">
                    <img :src="(scope.row.recordPhoto ? (imgUrl + scope.row.recordPhoto) : '') || defaultImg"
                      height="200px" class="head_pic" />
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="personName" label="认证状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.personName === '认证失败'" style="color:red">
                    {{ scope.row.personName }}</span>
                  <span v-else style="color:#37B328">
                    {{ scope.row.personName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
      prop="personName"
      width="100"

      label="认证状态">
    </el-table-column> -->
              <el-table-column prop="lal" label="设备来源">
              </el-table-column>
              <el-table-column prop="addressRelation" width="100" label="地区关系">
              </el-table-column>
              <el-table-column prop="nowAddress" label="认证地点">
              </el-table-column>
              <el-table-column prop="bak01" label="认证时间">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>

      <el-pagination class="pone" :page-size='10' layout="total, prev, pager, next, jumper" :total="totals"
        :current-page.sync="Page" @current-change="current_change">
      </el-pagination>
    </div>
    <el-dialog title="修改基础信息" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.name" size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.tel" size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="原身份证号" :label-width="formLabelWidth">
          <el-input v-model="form.idCard" readonly size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新身份证号" :label-width="formLabelWidth">
          <el-input v-model="form.newIdCard" size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="备注" :label-width="formLabelWidth" v-show="isRemakShow()">
          <el-select size="mini" v-model="form.companyName" filterable placeholder="请选择备注" @blur="selectBlur">
            <el-option v-for="item in companyNameList" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地区" :label-width="formLabelWidth">
          <Candode v-if="fres" v-on:childByValue="childByValue" v-on:getTownlength="getTownlength"></Candode>
        </el-form-item>
        <el-form-item label="单位名称" :label-width="formLabelWidth">
          <el-input v-model="form.corporation" size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="修改默认照片" :label-width="formLabelWidth">
          <div class="infoImg" @click="upload">
            <i v-if="isEmpty" style="font-size:50px;color:lightgray" class="el-icon-picture-outline"></i>
            <img v-else :src="base64Img" alt="">
          </div>
          <input type="file" ref="iptImg" v-show="false" @change="uploadFile">
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confim">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="删除个人信息" :visible.sync="dialogFormVisible2">
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="warning" @click="confirmDel">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增个人信息" :visible.sync="infoMsg">
      <el-form :model="addInfo">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="addInfo.name" size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="addInfo.tel" size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" :label-width="formLabelWidth">
          <el-input v-model="addInfo.idCard" size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="补贴类型" :label-width="formLabelWidth">
          <el-select size="mini" v-model="addInfo.verify_type" placeholder="请选择">
            <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地区" :label-width="formLabelWidth">
          <Candode v-on:childByValue="childByValue" ref="Candode" v-on:getTownlength="getTownlength"></Candode>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="infoMsg = false">取 消</el-button>
        <el-button type="primary" @click="addConfim">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改个人状态" :visible.sync="isState">
      <el-form :model="form">
        <el-form-item label="个人状态" :label-width="formLabelWidth">
          <div>
            <el-select v-model="Match" placeholder="请选择修改后的状态" @change="matchSelect">
              <el-option v-for="item in MatchList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
           
          </div>
        </el-form-item>
        <div style="height:10px"></div>
        <el-form-item v-show="isDie" label="死亡时间" :label-width="formLabelWidth">
          <el-date-picker v-model="time" type="date" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <div style="margin-top:20px" v-show="isstop">
          <el-form-item label="更新说明" :label-width="formLabelWidth">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="contant"></el-input>
          </el-form-item>
        </div>
        <div class="idie" v-show="isDie">{{ reson }}</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isState = false">取 消</el-button>
        <el-button type="primary" @click="confimState">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改银行卡号" :visible.sync="cbBank">
      <el-form>
        <el-form-item label="银行卡号" :label-width="formLabelWidth">
          <el-input v-model="changeBankNums" placeholder="请输入要修改的银行卡号" style="width:250px" autocomplete="off">
          </el-input>
          <el-button type="primary" @click="toBankName">识别</el-button>
        </el-form-item>
        <div style="height:10px"></div>
        <el-form-item label="银行名称" :label-width="formLabelWidth">
          <el-input v-model="bankType" placeholder="点击识别按钮进行智能录入" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cbBank = false">取 消</el-button>
        <el-button type="primary" @click="changeBankNum()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改补贴状态" :visible.sync="cbState">
      <el-form :model="cbform">
        <el-form-item label="补贴状态" :label-width="formLabelWidth">
          <div>
            <el-select v-model="cbMatch" @change="changeCb" placeholder="请选择修改后的状态">
              <el-option v-for="item in cbMatchList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

          </div>
        </el-form-item>
        <div style="margin-top:20px"></div>
        <el-form-item v-show="isTime" style="margin-top:20px" label="迁出时间" :label-width="formLabelWidth">
          <el-date-picker v-model="updateTime" type="date" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cbState = false">取 消</el-button>
        <el-button type="primary" @click="cbconfimState">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="状态详情" :visible.sync="isDetial">
      <el-form :model="form">
        <el-form-item label="操作人" :label-width="formLabelWidth">
          {{ person }}
        </el-form-item>
        <div style="margin-top:20px">
          <el-form-item label="停发原因" :label-width="formLabelWidth">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="reson">
            </el-input>
          </el-form-item>
          <el-form-item label="操作时间" :label-width="formLabelWidth">
            {{ timee }}
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isDetial = false">取 消</el-button>
        <el-button type="primary" @click="isDetial = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新增认证记录" :visible.sync="isaddRecord" width="30%">
      <el-form :model="record">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="record.name" readonly size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="所在地区" :label-width="formLabelWidth">
        <Candode v-on:childByValue="childByValue" v-on:getTownlength="getTownlength"></Candode>
    </el-form-item> -->
        <el-form-item label="身份证号" :label-width="formLabelWidth">
          <el-input v-model="record.idCard" readonly size="mini" style="width:250px" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="补贴类型" :label-width="formLabelWidth">
        <el-select size="mini" v-model="record.verify_type" placeholder="请选择">
    <el-option
      v-for="item in stateList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
    </el-form-item> -->
        <el-form-item label="默认照片" :label-width="formLabelWidth">
          <div class="infoImg" @click="uploadRecord">
            <i v-if="isEmptyRecord" style="font-size:50px;color:lightgray" class="el-icon-picture-outline"></i>
            <img v-else :src="base64ImgRecord" alt="">
          </div>
          <input type="file" ref="iptImgRecord" v-show="false" @change="uploadFileRecord">
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isaddRecord = false">取 消</el-button>
        <el-button type="primary" @click="addRecord">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style lang='scss' scoped>
.el-form-item {
  margin: 0 !important;
}

.el-form-item__content {
  text-align: left;
}

.infoImg {
  width: 100px;
  border-radius: 10px;
  border: 1px solid lightgray;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
  }
}
.idie {
  padding: 15px;
}

.detialMsg {
  margin-top: 20px;
  overflow: hidden;

  .el-card__header {
    padding: 5px 5px;
    text-align: left;
    font-size: 14px;
  }

  .text {
    text-align: left;
    font-size: 14px;
    overflow: hidden;

    .basicPhoto,
    .basicInfo {
      float: left;
      list-style: none;
      padding: 0 0 0 10px;
      margin: 0;
    }

    .basicInfo {
      li {
        font-size: 14px;
        margin-bottom: 5px;
      }
    }

    .basicPhoto {
      padding: 0;
      width: 150px;
      border: 1px solid gray;

      img {
        width: 100%;
      }
    }
  }

  .changeSta {
    margin-left: 10px;
    color: #2782af;
    cursor: pointer;
  }

  .el-card__header {
    height: 30px;
  }

  .el-card__body {
    min-height: 160px;
  }

  .changeBasic {
    border: 1px solid lightgray;
    float: right;
    cursor: pointer;
  }

  .changeBasic:hover {
    color: #2782af;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .box-card {
    width: 100%;
  }

  .ownMsg {
    float: left;
    width: 49%;
    margin-bottom: 20px;
  }

  .photoList {
    float: right;
    width: 48%;
    margin-right: 2px;
    margin-bottom: 20px;

    .kuImg {
      img {
        height: 169px;
        margin-left: 10px;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .ownMsg {
      float: left;
      width: 100%;
    }

    .photoList {
      float: left;
      width: 100%;
    }
  }
}

.List {
  .el-card__header {
    padding: 5px 5px;
    text-align: left;
    font-size: 14px;
  }
}

.op {
  display: flex;
  align-items: center;
}

.idc {
  width: 200px;
}

.nam {
  margin-right: 20px;
}

.ywtyoe {
  width: 200px;
  margin-left: 20px;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.pone {
  margin-top: 40px;
}

.el-timeline {
  padding-left: 20px;
}

.add {
  margin-left: 20px;
}
</style>

<script>
import Axios from "axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { Loading } from "element-ui";
import { listtown } from "../../utils/address";
import defaultImg from "../../assets/defaultPicture.jpg";
import Candode from "../Core/candode";
import KtButton from "@/views/Core/KtButton";
import { getType } from "../../utils/typeAuth";
import { formatDate } from "../../utils/datetimeYMR";
import { hasPermission } from "@/permission/index.js";

export default {
  components: {
    Candode,
    KtButton
  },
  data() {
    return {
      fres: true,
      cblx: "",
      updateTime: "",
      isTime: false,
      isNew: "",
      age: "",
      cbBank: false,
      changeBankNums: "",
      isstop: false,
      contant: "",
      time: "",
      isDie: false,
      cbState: false,
      dieInfo: "",
      cbMatch: 0,
      bankType: "",
      cbMatchList: [
        {
          label: "正常",
          value: 0
        },
        {
          label: "待遇停发",
          value: 4
        },
        {
          label: "户籍迁出",
          value: -1
        }
      ],
      Match: 0,
      MatchList: [
        {
          label: "正常",
          value: 0
        },
        {
          label: "已死亡",
          value: 5
        }
      ],
      adrState: "",
      bank_num: "",
      //地区
      list: "",
      isState: false,
      townList: [],
      infoMsg: false,
      base64Img: "",
      base64ImgRecord: "",
      dialogFormVisible: false,
      dialogFormVisible2: false,
      featureDtoList: [],
      isEmpty: true,
      isEmptyRecord: true,
      cbform: {
        libId: "",
        idCard: "",
        verifyType: "",
        adrState: ""
      },
      form: {
        name: "",
        tel: "",
        idCard: "",
        verify_type: "",
        newIdCard: "",
        corporation: "",
        companyName: ""
      },
      companyNameList: [],
      addInfo: {
        name: "",
        tel: "",
        idCard: "",
        verify_type: ""
      },
      verify_types: [],
      isaddRecord: false,
      record: {
        name: "",
        idCard: "",
        addressRelation: "",
        verify_type: ""
      },
      addressRelationList: [
        {
          value: "本地",
          label: "本地"
        },
        {
          value: "异地",
          label: "异地"
        }
      ],
      formLabelWidth: "120px",
      defaultImg: defaultImg,
      isShow: false,
      basicPhoto: "",
      loading: false,
      totals: 0,
      Page: 1,
      personName: "",
      idc: "",
      operate_name: "",
      telphone: "",
      bak01: "", //补贴状态
      authAdress: "",
      tableData: [],
      stateList: [],
      imgUrl: "http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/",
      idNo: "",
      options: [],
      value: "",
      lib_id: "",
      reson: "",
      isDetial: false,
      person: "",
      timee: "",
      photoPath: ""
    };
  },
  methods: {
    changeCb() {
      if (this.cbMatch == "-1") {
        this.isTime = true;
      } else {
        this.isTime = false;
        this.updateTime = "";
      }
    },
    selectBlur(e) {
      // if (e.target.value) {
      //  // 不在表单的时候不需要判断，也不需要isname字段
      //     this.form.companyName = e.target.value;
      //     this.isName = true;
      // } else {
      //     this.isName = false;
      // }
      this.form.companyName = e.target.value;
    },
    toup() {
      this.idNo = this.idNo.toUpperCase();
    },
    toBankName() {
      let data = {
        bankNo: this.changeBankNums
      };
      this.$api.getlist
        .getBankNume(data)
        .then(res => {
          if (res.code == 200) {
            this.bankType = res.data;
            if (!res.data) {
              this.$message({
                type: "warning",
                message: "未识别成功,请手动输入"
              });
            }
          } else {
            this.$message({
              type: "warning",
              message: "未识别成功,请手动输入"
            });
            this.bankType = "";
          }
        })
        .catch(res => {});
    },
    //修改银行卡
    changeBank() {
      this.cbBank = true;
    },
    changeBankNum() {
      let data = {
        identityNumber: this.Encrypt(this.idc),
        lib_id: this.lib_id,
        adrId: this.value.split(",")[6],
        bankNo: this.changeBankNums,
        bak01: this.value.split(",")[2],
        verify_type: this.value.split(",")[4],
        bankType: this.bankType
      };
      this.$api.getlist
        .updateBankNo(data)
        .then(res => {
          this.cbBank = false;
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.serch();
          } else {
            this.$message({
              type: "warning",
              message: res.message
            });
          }
        })
        .catch(function(err) {
          // this.$message({
          //         type:"warning",
          //         message:"未知异常"
          //       })
        });
    },
    //查看状态
    look(s, isp) {
      if (!isp) {
        this.isDetial = true;
      }

      let data = {
        idCard: this.Encrypt(this.idc),
        operate: s
      };
      this.$api.getlist
        .stateLog(data)
        .then(res => {
          if (!isp) {
            this.isState = false;
          }

          if (res.code == 200) {
            this.reson = res.data[0].operate;
            this.person = res.data[0].admin;
            this.timee = res.data[0].bak1;
          } else {
            this.$message({
              type: "warning",
              message: res.message
            });
          }
        })
        .catch(function(err) {
          // this.$message({
          //         type:"warning",
          //         message:"未知异常"
          //       })
        });
    },
    //状态选择
    matchSelect() {
      if (this.Match == 4) {
        this.isstop = true;
        this.isDie = false;
      } else if (this.Match == 5) {
        this.isstop = false;
        this.contant = "";
        this.isDie = true;
      } else {
        this.isDie = false;
        this.isstop = false;
        this.contant = "";
      }
    },
    cbchangeSta() {
      this.cbState = true;
    },
    changeSta() {
      this.look(6, 1);
      this.isState = true;
    },
    cbchangever() {
      this.$confirm("是否更新时间?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            libId: this.lib_id,
            verifyType: this.value.split(",")[4]
          };
          this.$api.getlist.updatetime(data).then(res => {
            this.isState = false;
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "更新成功"
              });
              this.serch();
            } else {
              this.$message({
                type: "warning",
                message: res.message
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //确定修改
    cbconfimState() {
      if (this.cbMatch == "-1" && !this.updateTime) {
        this.$message({
          type: "warn",
          message: "请选择迁出时间!"
        });
        return;
      }

      let data = {
        idCard: this.Encrypt(this.idc),
        libId: this.lib_id,
        adrId: this.value.split(",")[6],
        adrState: this.cbMatch,
        verifyType: this.value.split(",")[4],
        updateTime: this.updateTime ? formatDate(this.updateTime) : ""
      };
      this.$api.getlist
        .updateadrState(data)
        .then(res => {
          this.cbState = false;
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.serch();
          } else {
            this.$message({
              type: "warning",
              message: res.message
            });
          }
        })
        .catch(function(err) {
          // this.$message({
          //         type:"warning",
          //         message:"未知异常"
          //       })
        });
    },
    confimState() {
      if (!this.contant && this.isstop) {
        this.$message({
          type: "warning",
          message: "请输入停发原因"
        });
        return;
      }
      let data = {
        identityNumber: this.Encrypt(this.idc),
        data_state: this.Match,
        isNew:
          this.bak01 == "正常"
            ? 0
            : this.bak01 == "已死亡"
              ? 5
              : this.bak01 == "停止发放社保"
                ? 4
                : "",
        lib_id: this.lib_id,
        adrId: this.value.split(",")[6],
        verify_type: this.value.split(",")[4],
        fromModel: this.isDie
          ? this.time
            ? formatDate(this.time)
            : ""
          : this.contant
      };
      this.$api.getlist
        .updateState(data)
        .then(res => {
          this.isState = false;
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.serch();
          } else {
            this.$message({
              type: "warning",
              message: res.message
            });
          }
        })
        .catch(function(err) {});
    },
    childByValue(val) {
      this.townList = val;
    },
    getTownlength(val) {
      this.townlen = val;
    },
    //新增
    addMessage() {
      this.infoMsg = true;
      this.addInfo = {
        name: "",
        tel: "",
        idCard: "",
        verify_type: ""
      };
      this.$refs.Candode.value = "";
      this.townList = [];
    },
    upload() {
      this.$refs.iptImg.click();
    },
    uploadRecord() {
      this.$refs.iptImgRecord.click();
    },
    uploadFile() {
      this.isEmpty = false;
      let that = this;
      let file = this.$refs.iptImg.files[0];
      let render = new FileReader();
      render.readAsDataURL(file);
      render.onload = function() {
        that.base64Img = this.result;
      };
    },
    uploadFileRecord() {
      this.isEmptyRecord = false;
      let that = this;
      let file = this.$refs.iptImgRecord.files[0];
      let render = new FileReader();
      render.readAsDataURL(file);
      render.onload = function() {
        that.base64ImgRecord = this.result;
        console.log(that.base64ImgRecord);
      };
    },
    //修改基础信息
    changeBasicInfo() {
      console.log(this.value);
      this.dialogFormVisible = true;
      this.form.name = this.personName;
      this.form.tel = this.telphone;
      this.form.idCard = this.idNo;
      this.form.newIdCard = this.newIdCard;
      this.form.corporation = this.corporation;
    },
    //删除基础信息
    delBasicInfo() {
      this.dialogFormVisible2 = true;
    },
    //新增确认
    addConfim() {
      let flag =
        this.addInfo.name &&
        this.townList[4] &&
        this.addInfo.verify_type &&
        this.addInfo.idCard;
      if (!this.townList[4]) {
        this.$message({
          message: "地区不全!",
          type: "warning"
        });
        return;
      }
      if (!flag) {
        this.$message({
          message: "信息不全!",
          type: "warning"
        });
        return;
      }
      let data = {
        personName: this.addInfo.name ? this.Encrypt(this.addInfo.name) : "",
        telphone: this.addInfo.tel ? this.Encrypt(this.addInfo.tel) : "",
        provinceName: this.townList[0].split(",")[1],
        cityName: this.townList[1].split(",")[1],
        countryName: this.townList[2].split(",")[1],
        townName: this.townList[3].split(",")[1],
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        villageName: this.townList[4].split(",")[1],
        verify_type: this.addInfo.verify_type,
        identityNumber: this.Encrypt(this.addInfo.idCard)
      };
      this.loadding = true;
      this.$api.getlist
        .addLib(data)
        .then(res => {
          this.loadding = false;
          this.infoMsg = false;
          if (res.code == 200) {
            this.$message({
              message: res.describe,
              type: "success"
            });
          } else {
            this.$message({
              message: res.describe,
              type: "info"
            });
          }
        })
        .catch(res => {
          this.loading = false;
        });
    },
    //更新确认
    confim() {
      console.log(this.townList);
      if (this.townList.length < 5 && this.townList.length > 0) {
        this.$message({
          message: "地区选择不完整",
          type: "warning"
        });
        return;
      }
      if (this.townList[2]) {
        if (
          this.value.split(",")[7] != this.townList[2].split(",")[1] &&
          sessionStorage.getItem("user") != "admin"
        ) {
          this.$message({
            message: "区县不一致，请联系管理员修改",
            type: "warning"
          });
          return;
        }
      }
      this.fres = false;
      this.$nextTick(() => {
        this.fres = true;
      });
      let data = {
        personName: this.form.name ? this.Encrypt(this.form.name) : "",
        telphone: this.form.tel ? this.Encrypt(this.form.tel) : "",
        collectImg: this.base64Img.split(",")[1],
        identityNumber: this.Encrypt(this.form.idCard),
        provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
        cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
        countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
        townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        villageName: this.townList[4] ? this.townList[4].split(",")[1] : "",
        lib_id: this.lib_id,
        corporation: this.form.corporation,
        companyName: this.form.companyName,
        newIdCard: this.form.newIdCard ? this.Encrypt(this.form.newIdCard) : "",
        adrId: this.value.split(",")[6],
        verify_type: this.value.split(",")[4]
      };
      this.loadding = true;
      this.$api.getlist
        .updateLib(data)
        .then(res => {
          this.loadding = false;
          this.dialogFormVisible = false;
          if (res.code == 200) {
            this.$message({
              message: res.describe,
              type: "success"
            });
            this.serch();
          } else {
            this.$message({
              message: res.describe,
              type: "info"
            });
          }
        })
        .catch(res => {
          this.loading = false;
        });
    },

    //删除确认
    confirmDel() {
      let data = {
        lib_id: this.lib_id,
        idCard: this.Encrypt(this.idc)
      };
      this.$api.getlist
        .delPersonInfo(data)
        .then(res => {
          this.dialogFormVisible2 = false;
          if (res.code == 200) {
            this.$message({
              message: res.message,
              type: "success"
            });
            this.serch();
          } else {
            this.$message({
              message: res.message,
              type: "info"
            });
          }
        })
        .catch(res => {});
    },

    getTownlength(val) {
      this.townlen = val;
    },
    //搜索
    serch() {
      let addressList = JSON.parse(sessionStorage.getItem("list"));
      this.options = [];
      this.loading = true;
      let data = {
        identityNumber: this.Encrypt(this.idNo),
        pageNum: 1,
        pageSize: 10,
        provinceName: addressList.province
          ? addressList.province.split(",")[1]
          : "",
        cityName: addressList.city ? addressList.city.split(",")[1] : "",
        countryName: addressList.country
          ? addressList.country.split(",")[1]
          : "",
        townName: addressList.town ? addressList.town.split(",")[1] : "",
        villageName: addressList.village
          ? addressList.village.split(",")[1]
          : ""
      };
      this.$api.getlist
        .findByIdNo(data)
        .then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.lib_id = res.result.id;
            this.isShow = true;
            this.isNew = res.result.isNew;
            this.age = res.result.age;
            this.totals = res.page ? res.page.total_count : 0;
            this.personName = this.decrypt(res.result.personName);
            this.idc = this.decrypt(res.result.identityNumber);
            this.operate_name = res.result.operate_name;
            this.telphone = res.result.telphone
              ? this.decrypt(res.result.telphone)
              : "";
            this.bak01 = res.result.bak01;
            if (this.bak01 == "已死亡") {
              this.isDie = true;
            } else {
              this.isDie = false;
            }
            this.Match =
              res.result.bak01 == "正常"
                ? 0
                : res.result.bak01 == "已死亡"
                  ? 5
                  : res.result.bak01 == "停止发放社保"
                    ? 4
                    : "";
            this.basicPhoto = res.result.defaultPhoto
              ? this.imgUrl + res.result.defaultPhoto
              : defaultImg;
            this.photoPath = res.result.defaultPhoto;
            this.tableData = res.result.authRecordEntityList;
            this.featureDtoList = res.result.featureDtoList;
            let list = res.result.addressDtoList;
            this.list = res.result.addressDtoList[0];
            this.record.name = this.personName;
            this.record.idCard = this.idc;
            for (let i in list) {
              this.options.push({
                value:
                  list[i].provinceName +
                  list[i].cityName +
                  list[i].countryName +
                  list[i].townName +
                  list[i].villageName +
                  "," +
                  list[i].bak01 +
                  "," +
                  list[i].bankNo +
                  "," +
                  list[i].adrState +
                  "," +
                  list[i].verify_type +
                  "," +
                  list[i].bankType +
                  "," +
                  list[i].id +
                  "," +
                  list[i].countryName +
                  "," +
                  list[i].companyName +
                  "," +
                  list[i].recordTime,
                label: getType(list[i].verify_type)
              });
              console.log(this.options);
              this.verify_types.push(list[i].verify_type);
            }
            this.value =
              list[0].provinceName +
              list[0].cityName +
              list[0].countryName +
              list[0].townName +
              list[0].villageName +
              "," +
              list[0].bak01 +
              "," +
              list[0].bankNo +
              "," +
              list[0].adrState +
              "," +
              list[0].verify_type +
              "," +
              list[0].bankType +
              "," +
              list[0].id +
              "," +
              list[0].countryName +
              "," +
              list[0].companyName +
              "," +
              list[0].recordTime;
            console.log(this.value.split(",")[4]);
            if (this.value.split(",")[4] == 26) {
              this.companyNameList = [
                {
                  value: "自理",
                  label: "自理"
                },
                {
                  value: "轻度",
                  label: "轻度"
                },
                {
                  value: "中度",
                  label: "中度"
                },
                {
                  value: "重度",
                  label: "重度"
                }
              ];
            }
          } else {
            this.$message({
              type: "warning",
              message: res.describe
            });
          }
        })
        .catch(res => {
          this.loading = false;
        });
    },
    current_change(ss) {
      this.options = [];
      this.loading = true;
      let data = {
        identityNumber: this.Encrypt(this.idNo),
        pageNum: ss,
        pageSize: 10
      };
      this.$api.getlist
        .findByIdNo(data)
        .then(res => {
          this.loading = false;

          if (res.code == 200) {
            this.isShow = true;
            this.totals = res.page ? res.page.total_count : 0;
            this.personName = this.decrypt(res.result.personName);
            this.idc = this.decrypt(res.result.identityNumber);
            this.operate_name = res.result.operate_name;
            this.telphone = res.result.telphone
              ? this.decrypt(res.result.telphone)
              : "";
            this.bak01 = res.result.bak01;
            this.Match =
              res.result.bak01 == "正常"
                ? 0
                : res.result.bak01 == "已死亡"
                  ? 5
                  : res.result.bak01 == "停止发放社保"
                    ? 4
                    : "";
            this.basicPhoto = res.result.defaultPhoto
              ? this.imgUrl + res.result.defaultPhoto
              : defaultImg;
            this.photoPath = res.result.defaultPhoto;
            this.tableData = res.result.authRecordEntityList;
            this.featureDtoList = res.result.featureDtoList;
            let list = res.result.addressDtoList;
          } else {
            this.$message({
              type: "warning",
              message: res.describe
            });
          }
        })
        .catch(res => {
          this.loading = false;
        });
    },

    Encrypt(word) {
      //aes加密
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    decrypt(word) {
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    decryptByDES(ciphertext) {
      var keyHex = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypted = CryptoJS.DES.decrypt(
        {
          ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
        },
        keyHex,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    },
    //新增记录
    addRecord() {
      this.loading = true;
      this.isaddRecord = false;
      let data = {
        provinceName: this.list.provinceName,
        cityName: this.list.cityName,
        countryName: this.list.countryName,
        townName: this.list.townName,
        villageName: this.list.villageName,
        recordPhoto: this.base64ImgRecord.split(",")[1],
        userId: sessionStorage.getItem("deptId"),
        lib_id: this.lib_id,
        verify_types: this.verify_types.join(","),
        identityNumber: this.Encrypt(this.record.idCard),
        photoPath: this.photoPath
      };
      this.$api.getlist
        .addauthrecord(data)
        .then(res => {
          this.loading = false;

          if (res.code == 200) {
            this.isaddRecord = false;
            this.$message({
              type: "success",
              message: res.message
            });
            this.verify_types = [];
            this.serch();
          } else {
            this.$message({
              type: "warning",
              message: res.message
            });
          }
        })
        .catch(err => {});
    },
    isRemakShow() {
      return hasPermission("update:company:edit");
    }
  },

  created() {
    if (this.$route.params.idcard) {
      this.idNo = this.$route.params.idcard;
      this.serch();
    }
    //    let Obj=JSON.parse(sessionStorage.getItem("datas"))
    // if(sessionStorage.getItem("datas")){
    //    Object.assign(this.$data, JSON.parse(sessionStorage.getItem("datas")));
    //    this.cblx=""
    //    this.stateList=[]
    //    this.flag=true
    // }

    let arr;
    if (sessionStorage.getItem("typeControll") == "null") {
      arr = JSON.parse(sessionStorage.getItem("codes"));
    } else {
      arr = JSON.parse(
        sessionStorage.getItem("typeControll").replace(/\"/g, "")
      );
    }

    for (let i in arr) {
      this.stateList.push({
        label: getType(arr[i]),
        value: arr[i]
      });
    }
    console.log(arr);
    this.addInfo.verify_type = arr[0] ? arr[0] : "";
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Myvue/ownInfo.vue